<template>
  <div class="content">
    <div class="content__row">
      <div class="content__column content__column--wide">
        <h1 class="content__title">Diseñadores</h1>
      </div>
    </div>
    <div class="content__row">
      <brand-list :filters="filters"></brand-list>
      <brand-view :brand="brand" v-if="brandAction === 'view' && brand"></brand-view>
      <brand-edit @new="newBrand" :brand="brand" v-if="brandAction === 'edit'" :key="key"></brand-edit>
      <div class="content__column content__column--small">
        <h1 class="content__title">Opciones</h1>
        <div class="information">
          <h2 class="content__subtitle">Filtro</h2>
          <div class="form__container">
            <label for="search" class="form__label">búsqueda Libre</label>
            <input type="text" name="search" id="search" class="form__input" v-model="search" @keyup="setFilters">
          </div>
          <div class="form__container">
          <label class="form__label form__label--required" for="status_id">Filtrar por estatus</label>
          <div class="form__select-container">
            <select name="status_id" id="status_id" class="form__select" v-model="status_id" @change="setFilters">
              <option hidden :value="null">Selecciona un estatus</option>
              <option v-for="(status, index) in brandStatus" :key="index" :value="status.id" v-text="status.name"></option>
            </select>
          </div>
        </div>
        </div>
      </div>
    </div>
    <button @click.prevent="newBrand" class="btn btn__add">Agregar</button>
  </div>
</template>

<script>
import httpService from '@/core/api/request'
import brandList from './list'
import brandView from './view'
import brandEdit from './edit'
import Mixins from './mixins'
import {brandStatus} from './mocks'
export default {
  mixins: [
    httpService,
    Mixins
  ],
  components: {
    brandList,
    brandView,
    brandEdit
  },
  data: function () {
    return {
      brandStatus: brandStatus,
      key: 0,
      search: null,
      status_id: null,
      filters: undefined,
      brandAction: false,
      brand: null
    }
  },
  mounted: function () {
    this.$on('view',id => {
      this.getBrand(id, 'view')
    })
    this.$on('edit',id => {
      this.getBrand(id, 'edit')
    })
  },
  methods: {
    setFilters: function () {
      let filter = ''
      if (this.search && this.search.length > 1) {
        filter = filter + '&search=' + this.search
      }
      if (this.status_id) {
        filter = filter + '&status_id=eq:' + this.status_id
      }
      filter = filter.replace(/(^&+|&+$)/, '')
      if (filter.length > 0) {
        this.filters = filter
      } else {
        this.filters = undefined
      }
    },
    getBrand: function (id, action) {
      this.brandAction = false
      let httpRequest = {
        params: '',
        module: 'brands'
      }
      this.getById(id, httpRequest)
        .then(
          brand => {
            this.brand = brand.data
						this.brandAction = action
          }
        )
    },
    newBrand: function () {
      this.brand = undefined
      this.key = ++this.key
      this.brandAction = 'edit'
    }
  }
}
</script>

<style lang="sass">
  @import "../../assets/sass/components/_home"
  @import "../../assets/sass/components/_forms"
</style>



// WEBPACK FOOTER //
// src/components/designers/designers.vue